import Display from '../../../../common/components/Display';
import T, { t } from '../../../../common/components/T';
import css from './components/SelectProductsModal/SelectProductsModal.module.scss';

export const thead = {
    data: [
        {
            type: 'text',
            name: 'name',
            title: <T textName='name' defaultStr='Название' />
        },
        {
            type: 'text',
            name: 'total',
            title: <T textName='total' defaultStr='Итого' />
        },
        {
            type: 'counter',
            name: 'quantity',
            title: <T textName='qty' defaultStr='Кол-во' />
        },
        {
            type: 'button',
            name: 'actions'
        }
    ]
};

const createName = (item, translation) => {
    const fullItem = item;
    const isSet = fullItem.type === 'set';
    return isSet ? (
        <div className={css.setName}>
            <p>{fullItem.name}</p>
            <p>{fullItem?.price?.price_for_client_formatted}</p>
            {fullItem?.set_products?.map((prod) => (
                <p key={prod.id}>{`${prod.name} - ${prod.count} ${t('pc', 'шт', 'all', translation)}`}</p>
            ))}
        </div>
    ) : (
        <div className={css.setName}>
            <p>{fullItem.name}</p>
            <p>{fullItem?.price?.price_for_client_formatted}</p>
        </div>
    );
};

export const transformData = (translation) => (data) => {
    return {
        ...data,
        data: data?.data?.map((item) => ({
            name: createName(item, translation),
            total: (
                <Display
                    type='value'
                    data={{
                        value: item?.price?.price_for_client * item?.quantity,
                        currency: { symbol: item?.price?.currency_symbol }
                    }}
                />
            ),
            quantity: item?.quantity || 1,
            actions: {
                destroy: {}
            },
            fullData: item,
            id: item?.id
        }))
    };
};
